import React from 'react'
import { CountrySelect as UICountrySelect, CountrySelectProps } from '@agro-club/frontend-shared'
import { COUNTRIES } from 'modules/constants'

export const CountrySelect: React.FC<CountrySelectProps> = ({ value, list, ...props }) => {
  return <UICountrySelect {...props} value={value} list={list || COUNTRIES} />
}
